<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="customShiftName"
    item-value="shiftCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'ShiftInput',

  mixins: [APIUtils, Message],

  components: {
    SelectSingleInput,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: true,
    },
    label: {
      type: String,
      required: false,
    },
    shiftGroupCd: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0130')
      },
    },
  },

  watch: {
    /**
     * Trigger when shift group code is changed
     * シフトグループコードが変更されたときにトリガー
     */
    shiftGroupCd() {
      this.fetchData()
    },
  },

  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = {
          validOnly: this.validOnly,
          shiftGroupcd: this.shiftGroupCd,
        }
        this.items = []
        const elements = await API.get('/master/shifts', params)
        this.items = elements.map((element) => {
          element['customShiftName'] = element['shiftCd'] + ' : ' + element['shiftName']
          return element
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0130') })))
      } finally {
        this.loading = false
      }
    },
  },

  async mounted() {
    this.fetchData()
  },
}
</script>
